import { useQuery } from '@apollo/client';
import { createError } from '@common/neo.tax';

import { useAscContext } from '@neo.tax/asc/context';
import {
  GET_ASC_SNAPSHOT_DOCUMENT_EVENTS,
  GetAscSnapshotDocumentEventsQuery,
  GetAscSnapshotDocumentEventsQueryVariables,
  useCurrentUserScopeForCurrentCompany,
} from '@neo.tax/shared';

export type AscSnapshotDocumentEvent = GetAscSnapshotDocumentEventsQuery['getAscSnapshotDocumentEvents'][number];

export type UseAscSnapshotDocumentEvents =
  | {
      documentEvents: AscSnapshotDocumentEvent[];
      loading: false;
    }
  | {
      documentEvents: null;
      loading: true;
    };

export const useAscSnapshotDocumentEvents = (): UseAscSnapshotDocumentEvents => {
  const { fiscalYearId } = useAscContext();
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();
  const shouldSkip = limitAccessToFinancialData;

  const { data, loading } = useQuery<GetAscSnapshotDocumentEventsQuery, GetAscSnapshotDocumentEventsQueryVariables>(
    GET_ASC_SNAPSHOT_DOCUMENT_EVENTS,
    { variables: { fiscalYearId }, skip: shouldSkip },
  );

  if (loading) {
    return { documentEvents: null, loading: true };
  }
  if (shouldSkip) {
    return { documentEvents: [], loading: false };
  }

  if (!data) {
    throw createError('No data returned from useAscSnapshotDocumentEvents');
  }

  return { documentEvents: data.getAscSnapshotDocumentEvents, loading: false };
};
